import React from "react";
import { useStore } from "./store";
import { AnimeSettings } from "./components/AnimeSettings";
import { BroadcastSettings } from "./components/BroadcastSettings";
import { ItemSelector } from "./components/ItemSelector";

function Main() {
  const { anime, broadcast } = useStore();

  return (<>
    <ItemSelector/>
    {
      anime && (
        broadcast ?
          <BroadcastSettings/> :
          <AnimeSettings/>
      )
    }
  </>);
}

export default Main;
